import { Component, OnInit, Input } from '@angular/core';
import {  ActivatedRoute } from '@angular/router';
import { PendingHorseShowEntryService } from '../../providers/pending-horse-show-entry.service';
import { HorseShowService } from '../../providers/horse-show.service';
import { WaiverService } from '../../providers/waiver.service';
import { Horse_show } from '../../models/horse_show';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { Horse } from '../../models/horse';
import { Person } from '../../models/person';
import { Signature } from '../../models/signature';
import { Waiver } from '../../models/waiver';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import * as dayjs from 'dayjs';

@Component({
  standalone: false,
  selector: 'app-print-entry-form',
  templateUrl: './print-entry-form.component.html',
styleUrls:  ['./print-entry-form.component.css']
})
export class PrintEntryFormComponent  extends SmsAbstractAppPage implements OnInit {

	waiver_text: string = '';
	horse_show: Horse_show = new Horse_show({});
	horse_show_entry: Horse_show_entry = new Horse_show_entry({});
	signature_list_even: Signature[] = [];
	signature_list_odd: Signature[] = [];

  constructor(private route: ActivatedRoute,
  	private pendingHorseShowEntryService:PendingHorseShowEntryService,
  	private horseShowService: HorseShowService,
  	private waiverService:WaiverService) {
  	super();
  }

  ngOnInit() {
  	this.route.params.subscribe(params => {
          if(params['entry_id']){
				//Get horse show entry
		  	this.pendingHorseShowEntryService.get(params['entry_id']).then(horse_show_entry => {

		  		this.horse_show_entry = horse_show_entry;
				//Divide signatures into odd and even lists
				this.doArrangeSignatures(horse_show_entry.signature_list);

				//Get horse show
		  		this.horseShowService.get(horse_show_entry.horse_show_id).then(horse_show => {
		  			this.horse_show = horse_show;

		  			//Get waiver
					this.waiverService.get(horse_show.waiver_id).then(waiver =>{
						this.waiver_text = waiver.waiver_text;
					}).catch(error => {
						this.handleError(error);
					});
		  		}).catch(error => {
		  			this.handleError(error);
		  		});

		  	}).catch(error => {
		  		this.handleError(error);
		  	});

		  }
       });

  }

    private doArrangeSignatures(signature_list: Signature[]){
  	signature_list.forEach((signature, i) => {
  		if(i % 2 == 0){
  			this.signature_list_even.push(signature);
  		} else {
  			this.signature_list_odd.push(signature);
  		}
  	});
  }


}
